// src/components/AboutDetailed.js
import React from "react";
import { Link } from "react-router-dom";
import image1 from "../../assets/image1.png";
import image2 from "../../assets/image2.png";
import image3 from "../../assets/image3.png";
import image4 from "../../assets/image4.png";
import image5 from "../../assets/image5.png";
import image6 from "../../assets/image6.png";

const AboutDetailed = ({ language }) => {
  const aboutData = {
    mission: {
      title: { en: "Our Mission", ar: "رسالة الأكاديمية" },
      content: {
        en: "Inspiring workers, summoning and developing their capabilities, and motivating them to think and innovate through our programs in the fields of behavior, knowledge and skills.",
        ar: "إستنهاض همم العاملين وإستدعاء قدراتهم وتنميتها، وتحفيزهم على التفكير والابداع، من خلال برامجها في مجالات السلوك والمعرفة والمهارات.",
      },
    },
    vision: {
      title: { en: "Our Vision", ar: "رؤية الأكاديمية" },
      content: {
        en: '"Excellence".... Through establishing the idea of dual training - theoretical/practical - and adopting workshops as a means of transferring knowledge without traditional theoretical lectures.',
        ar: '"التمييز" .... من خلال ترسيخ فكرة التدريب المزدوج - نظري/عملي - واعتماد ورش العمل كوسيلة لنقل المعرفة دون المحاضرات النظرية التقليدية.',
      },
    },
    goals: {
      title: { en: "Our Goals", ar: "أهداف الأكاديمية" },
      items: [
        {
          en: "Preparing and qualifying new employees to integrate them into the work environment through the orientation and preparation program for assuming work.",
          ar: "تهيئة وإعداد العاملين الجدد لغرض دمجهم في بيئة العمل من خلال برنامج التهيأة والإعداد لاستلام العمل.",
        },
        {
          en: "Raising skills and developing the capabilities of employees to improve their performance level through continuous training programs.",
          ar: "رفع مهارات وتطوير قدرات العاملين للإرتقاء بمستوى أدائهم من خلال برامج التدريب المستمر.",
        },
        {
          en: "Building human cadres to be assigned to work in various locations in the group companies through specialized preparation programs.",
          ar: "بناء كوادر بشرية لإلحاقها بالعمل في المواقع المختلفة في شركات المجموعة من خلال برامج الإعداد المتخصصة.",
        },
        {
          en: "Preparing employees nominated for promotion to higher job categories with good preparation that aligns with the requirements of those categories.",
          ar: "إعداد العاملين المرشحين للترقية الى الفئات الوظيفية الأعلى إعداداً جيداً ينسجم مع متطلبات تلك الفئات.",
        },
      ],
    },
    history: {
      title: {
        en: "Detailed History of Arma Academy",
        ar: "نبدة تاريخية عن الاكاديمية",
      },
      subtitle: {
        en: "From Establishment to Present",
        ar: "من التأسيس وحتى الوقت الحاضر",
      },
      sections: [
        {
          year: "1986-1987",
          title: {
            en: "Establishment in Yemen",
            ar: "التأسيس في اليمن",
          },
          content: {
            en: "In 1986-1987, the Technical and Administrative Training Center of HSA Group of Companies was established in Taiz, Yemen. The center worked during the period until 1987-1993 on implementing programs to prepare mechanical maintenance technicians and electrical maintenance technicians through theoretical and practical training.",
            ar: "في عام 1986-1987 تأسس مركز التدريب الفني والإداري التابع لمجموعة شركات هائل سعيد أنعم HSA في مدينة تعز باليمن.",
          },
          details: {
            en: [
              { title: "The Center's Work (1987-1993):", withDots: false },
              {
                title:
                  "Implementation of Mechanical Maintenance Technician Preparation Program: Training intermediate school graduates for 24 months - theoretical and practical training.",
                withDots: true,
              },
              {
                title:
                  "Implementation of Electrical Maintenance Technician Preparation Program: Training high school graduates for 18 months - theoretical and practical training.",
                withDots: true,
              },
              {
                title:
                  "Implementation of 10 programs in administrative fields, including 6 English language teaching programs.",
                withDots: true,
              },
            ],
            ar: [
              {
                title:
                  " عمل المركز خلال الفترة حتى 1987-1993 على تنفيذ برامج :",
                withDots: false,
              },
              {
                title:
                  "إعداد فني صيانة ميكانيكية – حيث يتم تدريب خريجي الدراسة الإعدادية لمدة 24 شهراً – تدريب نظري وعملي.",
                withDots: true,
              },
              {
                title:
                  "إعداد فني صيانة كهربائية – حيث يتم تدريب خريجي الدراسة الثانوية لمدة 18 شهراً – تدريب نظري وعملي.",
                withDots: true,
              },
              {
                title:
                  "تنفيذ 10 برامج في المجالات الإدارية منها 6 برامج لتعليم اللغة الإنجليزية.",
                withDots: true,
              },
            ],
          },
        },
        {
          year: "1994-1995",
          title: {
            en: "Ambitious Training Plan",
            ar: "الخطة التدريبية الطموحة",
          },
          content: {
            en: "In 1994 (the year of the Yemeni Unity War), the Human Resources Department in the General Administration of the Group in Yemen developed an ambitious training plan that began implementation on 1/1/1995.",
            ar: "في العام 1994 (عام حرب الوحدة اليمنية) قامت إدارة الموارد البشرية في الادارة العامة للمجموعة في اليمن بوضع خطة تدريب طموحة نفذت بداية من 1/1/1995.",
          },
          details: {
            en: [
              {
                title:
                  "During 1995, 76 training programs were implemented in all fields, for example:",
                withDots: false,
              },
              {
                title:
                  "Human Resources Management program for HR staff (after changing its name from Personnel Affairs) from all companies",
                withDots: true,
              },
              {
                title:
                  "Human Resources Management program specifically for general managers and their deputies",
                withDots: true,
              },
              {
                title:
                  "Marketing program for marketing department staff from all companies",
                withDots: true,
              },
              {
                title:
                  "Marketing program specifically for general managers and their deputies",
                withDots: true,
              },
              {
                title:
                  "Finance programs for finance department staff from all companies",
                withDots: true,
              },
              {
                title:
                  "Finance programs specifically for general managers and their deputies",
                withDots: true,
              },
              {
                title:
                  "Similar programs in other fields such as production management, warehouses, maintenance, sales, etc.",
                withDots: true,
              },
            ],
            ar: [
              {
                title:
                  "حيث تم تنفيذ 76 برنامجاً تدريبياً خلال العام 1995 في كافة المجالات، منها على سبيل المثال:",
                withDots: false,
              },
              {
                title:
                  "برنامج في إدارة الموارد البشرية للعاملين في إدارات الموارد البشرية (بعد تغير مسماها من شئون العاملين) من جميع الشركات",
                withDots: true,
              },
              {
                title:
                  "برنامج في إدارة الموارد البشرية مخصص لمدراء عموم الشركات ونوابهم",
                withDots: true,
              },
              {
                title:
                  "برنامج في التسويق للعاملين في إدارات التسويق من جميع الشركات",
                withDots: true,
              },
              {
                title: "برنامج في التسويق مخصص لمدراء عموم الشركات ونوابهم",
                withDots: true,
              },
              {
                title:
                  "برامج في المالية للعاملين في الإدارات المالية من جميع الشركات",
                withDots: true,
              },
              {
                title: "برامج في المالية مخصص لمدراء عموم الشركات ونوابهم",
                withDots: true,
              },
              {
                title:
                  "وهكذا في المجالات الأخرى كإدارة الإنتاج – المخازن – الصيانة – المبيعات – وغيرها",
                withDots: true,
              },
            ],
          },
        },
        {
          year: "1995-1996",
          title: {
            en: "Transition to Technical Operator Program",
            ar: "التحول إلى برنامج المشغل الفني",
          },
          content: {
            en: "In 1995, the technician programs (Mechanical Maintenance and Electrical Maintenance) were changed to the 'Technical Operator Preparation' program - training only high school graduates (not intermediate) for 3 years.",
            ar: "في العام 1995 أيضا تم تغير برامج الفنيين (الصيانة الميكانيكية والصيانة الكهربائية) الى برنامج 'إعداد المشغل الفني'.",
          },
          details: {
            en: [
              {
                title:
                  "This system began on 1/1/1996 with the acceptance of a batch of 100 trainees - divided into two groups:",
                withDots: false,
              },
              {
                title:
                  "First group (50 trainees): Present at the training center 3 days a week for theoretical and practical training in the center's halls, workshops, and labs, and present in factories for field practical training in the other 3 days on 3 main topics: (Operations - Maintenance - Quality). A small training room was prepared in each production department (similar to what is called Quality Circles).",
                withDots: true,
              },
              {
                title:
                  "Second group (50 trainees): Present at the center and factories opposite the first group.",
                withDots: true,
              },
              {
                title:
                  "This batch graduated at the end of 1998 and its graduates were distributed to various factories to work as 'Technical Operators'.",
                withDots: true,
              },
            ],
            ar: [
              {
                title:
                  "حيث يتم تدريب خريجي الثانوية العامة فقط (دون الإعدادية) ولمدة 3 سنوات . تمت المباشرة بهذا النظام في 1/1/1996 حيث تم قبول دفعة من 100 متدرب – تم تقسيمهم على مجموعتين:",
                withDots: false,
              },
              {
                title:
                  "الأولى (50 متدرب): تتواجد في مركز التدريب 3 أيام في الأسبوع للتدريب النظري والعملي في قاعات وورش ومعامل المركز، وتتواجد في الـ 3 أيام الأخرى في المصانع للتدريب العملي الميداني على 3 موضوعات أساسية هي: (العمليات – الصيانة – الجودة) ، حيث تم تجهيز غرفة تدريب صغيرة في كل قسم إنتاجي (مشابهة لما يسمى بحلقات الجودة -Quality Circle)",
                withDots: true,
              },
              {
                title:
                  "والثانية (50متدرب): تتواجد في المركز والمصانع عكس الأولى.",
                withDots: true,
              },
              {
                title:
                  "تخرجت هذه الدفعة في نهاية عام 1998 وتم توزيع خريجيها على المصانع المختلفة للعمل بوظيفة 'مشغل فني'.",
                withDots: true,
              },
            ],
          },
        },
        {
          year: "1997-1999",
          title: {
            en: "Second Batch of Technical Operators",
            ar: "الدفعة الثانية من المشغلين الفنيين",
          },
          content: {
            en: "On 1/1/1997, 100 trainees were selected for the second batch, which started and applied the same system - graduating at the end of 1999.",
            ar: "في 1/1/1997 تم إختيار 100 متدرباً أيضاً للدفعة الثانية التي بدأت وطبق عليها نفس النظام – حيث تخرجت في نهاية عام 1999.",
          },
          details: {
            en: [
              {
                title:
                  "All graduates were employed in various factories within the group",
                withDots: false,
              },
            ],
            ar: [
              {
                title:
                  "تم تعيين جميع الخريجين في المصانع المختلفة ضمن المجموعة",
                withDots: false,
              },
            ],
          },
        },
        {
          year: "2006",
          title: {
            en: "Establishment in Egypt",
            ar: "التأسيس في مصر",
          },
          content: {
            en: "In February 2006, the Human Resources Department in the General Administration of Egypt Region proposed the establishment of Arma Academy, starting with the implementation of the Technical Operator Preparation program.",
            ar: "في فبراير من العام 2006 تقدمت إدارة الموارد البشرية في الادارة العامة لإقليم مصر بإستحداث أكاديمية آرما وتكون البداية في تنفيذ برنامج إعداد المشغلين الفنيين.",
          },
          details: {
            en: [
              {
                title: "The Academy implemented during the period 2006-2008:",
                withDots: false,
              },
              {
                isImage: true,
                images: [image1, image3],
                width: "30rem",
                height: "30rem",
              },
            ],
            ar: [
              {
                title: "نفذت الأكاديمية خلال الفترة 2006 – 2008 ما يلي:",
                withDots: false,
              },
              {
                isImage: true,
                images: [image1, image3],
                width: "30rem",
                height: "30rem",
              },
            ],
          },
        },
        {
          year: "2011",
          title: {
            en: "Name Change and New Programs",
            ar: "تغيير الاسم وبرامج جديدة",
          },
          content: {
            en: "In 2011, the academy's name was changed to 'Al-Saeed Academy'. The academy implemented various programs during 2011-2021.",
            ar: "في عام 2011 تم تغيير اسم الاكاديمية ليكون 'أكاديمية السعيد'. نفذت خلال الفترة 2011 – 2021 برامج متنوعة كما يلي: ",
          },
          details: {
            en: [
              {
                isImage: true,
                images: [image2, image4],
                width: "30rem",
                height: "30rem",
              },
              {
                title:
                  "In 2011, the program for preparing a shift operations manager was launched.",
                withDots: false,
              },
              {
                isImage: true,
                images: [image5],
                width: "100%",
                height: "100%",
              },
            ],
            ar: [
              {
                isImage: true,
                images: [image2, image4],
                width: "30rem",
                height: "30rem",
              },
              {
                title:
                  "وفي العام 2011 تمت المباشرة بتنفيذ بدنامج إعداد مدير عمليات وردية",
                withDots: false,
              },
              {
                isImage: true,
                images: [image5],
                width: "70%",
                height: "30rem",
              },
            ],
          },
        },
        {
          year: "2014",
          title: {
            en: "Management Trainees Program",
            ar: "برنامج المتدربين الإداريين",
          },
          content: {
            en: "In 2014, implementation of the Management Trainees preparation program began: ",
            ar: "في العام 2014 تمت المباشرة بتنفيذ برنامج إعداد المتدربين الاداريين حيث تم تخريج دفعتين وفق الاتي: ",
          },
          details: {
            en: [
              {
                isImage: true,
                images: [image6],
                width: "70%",
                height: "30rem",
              },
            ],
            ar: [
              {
                isImage: true,
                images: [image6],
                width: "70%",
                height: "30rem",
              },
            ],
          },
        },
        {
          year: "2020-2021",
          title: {
            en: "COVID-19 and New Management",
            ar: "جائحة كورونا والإدارة الجديدة",
          },
          content: {
            en: "In 2020, work at the academy stopped due to the COVID-19 pandemic (COVID-2019) and continued to stop until the General Administration of the Group's Egypt Region took over and the new administration was assigned to manage the region.",
            ar: "في العام 2020 توقف العمل في الاكاديمية بسبب جائحة كورونا (كوفيد 2019) وإستمر التوقف حتى تسلم الإدارة العامة للمجموعة إقليم مصر وتكليف الإدارة الجديدة بإدارة الاقليم.",
          },
          details: {
            en: [],
            ar: [],
          },
        },
      ],
    },
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        {/* Back button */}
        {/* <div className="mb-8" style={{marginTop: "10rem"}}>
          <Link
            to="/about"
            className="inline-flex items-center text-green-700 hover:text-green-800 font-medium"
          >
            <svg
              className="w-5 h-5 mr-2 rtl:mr-0 rtl:ml-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            {language === "ar"
              ? "العودة إلى الصفحة الرئيسية"
              : "Back to Main Page"}
          </Link>
        </div> */}

        {/* Page Header */}
        {/* <div className="text-center mb-12" style={{marginTop: "10rem"}}>
          <h1 className="text-4xl md:text-5xl font-bold text-green-900 mb-4">
            {language === "ar"
              ? "التاريخ الكامل للأكاديمية"
              : "Complete Academy History"}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {language === "ar"
              ? "رحلة تطور أكاديمية آرما من التأسيس حتى اليوم"
              : "The journey of Arma Academy's development from establishment to today"}
          </p>
          <div className="w-32 h-1 bg-green-600 mx-auto mt-6"></div>
        </div> */}

        {/* Mission & Vision */}
        {/* <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white p-8 rounded-xl shadow-lg border border-green-100">
            <h3 className="text-2xl font-bold text-green-900 mb-4">
              {aboutData.vision.title[language]}
            </h3>
            <p className="text-gray-700 text-lg leading-relaxed">
              {aboutData.vision.content[language]}
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg border border-green-100">
            <h3 className="text-2xl font-bold text-green-900 mb-4">
              {aboutData.mission.title[language]}
            </h3>
            <p className="text-gray-700 text-lg leading-relaxed">
              {aboutData.mission.content[language]}
            </p>
          </div>
        </div> */}

        {/* Goals */}
        {/* <div className="mb-16">
          <h2 className="text-3xl font-bold text-green-900 mb-8 text-center">
            {aboutData.goals.title[language]}
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {aboutData.goals.items.map((goal, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start">
                  <div className="flex-shrink-0 w-10 h-10 bg-green-100 text-green-800 rounded-full flex items-center justify-center font-bold text-lg mr-4 rtl:mr-0 rtl:ml-4">
                    {index + 1}
                  </div>
                  <p className="text-gray-700 text-lg">{goal[language]}</p>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Detailed History Timeline */}
        <div
          className="mb-16"
          style={{
            marginTop: "10rem",
          }}
        >
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-green-900 mb-2">
              {aboutData.history.title[language]}
            </h2>
            <p className="text-xl text-gray-600">
              {aboutData.history.subtitle[language]}
            </p>
          </div>

          {/* Timeline */}
          <div className="relative">
            {/* Timeline vertical line */}
            <div className="absolute left-0 md:left-1/2 transform md:-translate-x-1/2 w-2 h-full bg-green-600 hidden md:block"></div>

            {aboutData.history.sections.map((section, index) => (
              <div
                key={index}
                className={`relative mb-16 ${
                  index % 2 === 0
                    ? "md:pr-1/2 md:pl-0 md:pr-12"
                    : "md:pl-1/2 md:pr-0 md:pl-12"
                }`}
              >
                {/* Timeline dot */}
                <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-green-600 rounded-full border-4 border-white shadow-lg z-10 hidden md:block"></div>

                {/* Year marker */}
                <div
                  className={`mb-4 ${index % 2 === 0 ? "md:text-right" : ""}`}
                >
                  <span className="inline-block px-6 py-2 bg-green-600 text-white text-xl font-bold rounded-full shadow-lg">
                    {section.year}
                  </span>
                </div>

                {/* Content card */}
                <div className="bg-white rounded-xl shadow-xl overflow-hidden border border-green-100">
                  {/* Card header */}
                  <div className="bg-gradient-to-r from-green-700 to-green-800 p-6">
                    <h3 className="text-2xl font-bold text-white">
                      {section.title[language]}
                    </h3>
                  </div>

                  {/* Card body */}
                  <div className="p-8">
                    <p
                      className="text-gray-700 text-lg mb-6 leading-relaxed"
                      style={{
                        fontWeight: "bold",
                      }}
                    >
                      {section.content[language]}
                    </p>

                    {/* Details section */}
                    <div className="bg-green-50 p-6 rounded-lg border border-green-200">
                      {/* <h4 className="text-lg font-bold text-green-900 mb-4">
                        {language === "ar" ? "تفاصيل:" : "Details:"}
                      </h4> */}
                      <div className="space-y-3">
                        {section.details[language].map(
                          (detail, detailIndex) => (
                            <div key={detailIndex} className="flex items-start">
                              {detail.withDots === true ? (
                                <div className="flex-shrink-0 w-6 h-6 bg-green-200 text-green-800 rounded-full flex items-center justify-center mr-3 rtl:mr-0 rtl:ml-3 mt-1">
                                  •
                                </div>
                              ) : null}

                              <p
                                className="text-gray-700 flex-1"
                                style={{
                                  fontSize: !detail.withDots
                                    ? "1.2rem"
                                    : "1.1rem",
                                  fontWeight: !detail.withDots ? "bold" : "",
                                }}
                              >
                                {detail.title}
                              </p>
                              {detail.isImage === true ? (
                                <div className="flex justify-center w-full gap-10">
                                  {detail.images.map((image) => (
                                    <img
                                      src={image}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: `${detail.width}`,
                                        height: `${detail.height}`,
                                      }}
                                    />
                                  ))}
                                </div>
                              ) : null}
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Summary section */}
        {/* <div className="bg-gradient-to-r from-green-800 to-green-900 text-white p-10 rounded-2xl shadow-2xl">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold mb-4">
              {language === "ar" ? "ملخص الإنجازات" : "Achievements Summary"}
            </h3>
            <div className="w-24 h-1 bg-green-400 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            {[
              {
                number: "35+",
                label: { en: "Years of Excellence", ar: "سنة من التميز" },
              },
              {
                number: "2000+",
                label: { en: "Graduated Trainees", ar: "متدرب تخرج" },
              },
              {
                number: "150+",
                label: { en: "Training Programs", ar: "برنامج تدريبي" },
              },
              {
                number: "8",
                label: { en: "Major Programs", ar: "برنامج رئيسي" },
              },
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-green-300 mb-2">
                  {stat.number}
                </div>
                <div className="text-green-200 font-medium">
                  {stat.label[language]}
                </div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AboutDetailed;
